export default __webpack_public_path__ + "static/media/player.a2f6f3e3.png";